<template>
  <div class="icon" :style="style">
    <svg width="80" height="80" viewBox="0 0 85 85">
      <circle cx="42" cy="42" r="38" :stroke="color" stroke-width="3" fill="white" />

      <!-- Elektrická sústava z power-grid.svg -->
      <g transform="translate(29, 2) scale(0.06)">
        <path d="M343.04 1024H79.555048l52.053333-763.928381h159.378286z m-211.309714-48.761905h159.134476l-45.470476-666.404571h-68.266667z" fill="#3498db"/>
        <path d="M0 438.857143h414.47619v48.761905H0z" fill="#3498db"/>
        <path d="M24.380952 365.714286h48.761905v73.142857H24.380952z" fill="#3498db"/>
        <path d="M341.333333 365.714286h48.761905v73.142857h-48.761905z" fill="#3498db"/>
        <path d="M0 975.238095h414.47619v48.761905H0z" fill="#3498db"/>
      </g>
    </svg>
  </div>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
  x: Number,
  y: Number,
  label: String,
  color: {
    type: String,
    default: '#3498db'
  }
})

const style = computed(() => ({
  position: 'absolute',
  left: `${props.x - 30}px`,
  top: `${props.y - 30}px`,
  zIndex: 10
}))
</script>

<style scoped>
.icon {
  pointer-events: none;
}
</style>
